import type { DataGroupDto } from "../../types/DataGroupDto";
import type { DataGroupEntity } from "../../types/DataGroupEntity";

export const DataGroupEntityToDto = ({ idmUsers, entraUsers, ...rest }: Readonly<DataGroupEntity>): DataGroupDto => {
    const idmUserIds = idmUsers?.filter((user) => user.id !== undefined).map((user) => user.id as string) || []; // why user.id not user.userId?
    const entraUserIds = entraUsers?.filter((user) => user.userId !== undefined).map((user) => user.userId) || [];
    const userIds = [...entraUserIds, ...idmUserIds];

    return {
        ...rest,
        userIds: userIds || [],
    };
};
